import request from '@/utils/request'

// 获得社群二维码
export function getQRCode(params) {
  return request({
    url: '/product/activity/associationImg',
    method: 'GET',
    params,
  })
}
